<template>
  <v-dialog v-model="showModal" fullscreen persistent>
    <v-card>      
        <v-toolbar dark class="primary">
          <v-btn icon @click.native="showModal = false" dark>
            <v-icon>fa-times</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}</v-toolbar-title>                    
        </v-toolbar>                
        <v-card-text>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>          
        <v-form :class="visibility_class" @submit="handleSubmit">
                 <v-tabs
                    grow
                    v-model="active_tab"                                        
                    slider-color="primary"
                 >
                    <v-tab ripple key="0">Ogólne</v-tab>
                    <v-tab ripple key="1">Harmonogram</v-tab>    
                    <v-tab ripple key="2">Przerwy</v-tab>
                    <v-tab ripple key="3">Urlopy</v-tab>
                    <v-tab ripple key="4">Szybkie przerwy</v-tab>
                    <v-tab ripple key="5">Typy wizyt</v-tab>
                    <v-tab ripple key="6">Dodatkowe dni otwarte</v-tab>
                    <v-tab-item key="0">
                        <v-card flat>
                            <v-card-text>
                              <v-container fluid>
                                <v-row>
                                  <v-col>
                                    <v-container>
                                      <v-row>
                                        <v-col>
                                          <v-card>
                                            <v-toolbar flat color="white">
                                              <v-toolbar-title>Ustawienia Ogólne</v-toolbar-title>
                                            </v-toolbar>
                                            <v-card-text>
                                              <v-container  grid-list-xl>
                                                <v-row wrap>
                                                  <v-col cols="12">
                                                    <v-text-field label="Imię i nazwisko" name="name" id="name" disabled :value="Name + ' '+ Surname"></v-text-field>
                                                  </v-col>
                                                  <v-col cols="12">
                                                    <v-text-field label="Adres email" name="email" id="email" disabled :value="EmailAddress"></v-text-field>
                                                  </v-col>
                                                  <v-col cols="12">
                                                    <v-text-field label="Telefon" v-validate="{regex:/^[0-9\+]{8,13}$/}" data-vv-as="Telefon"
                                                                  name="phone" id="phone" v-model="Phone" :error-messages="errors.collect('phone')"></v-text-field>
                                                  </v-col>
                                                  <v-col cols="12">
                                                    <v-text-field label="Numer PWZ" name="PWZ" id="PWZ" v-model="PWZ"></v-text-field>
                                                  </v-col>
                                                  <v-col cols="12">
                                                    <v-text-field label="Czas wizyty" name="rate"  v-validate="'numeric'" data-vv-as="Czas wizyty" min="0"
                                                                  id="rate" v-model.number="VisitTime" step="5" type="number"
                                                                  :error-messages="errors.collect('VisitTime')">></v-text-field>
                                                  </v-col>
                                                  <v-col cols="12">
                                                    <v-text-field label="Koszt wizyty" name="rate"  v-validate="'decimal'" data-vv-as="Koszt wizyty" min="0"
                                                                  id="rate" v-model.number="Rate" step="0.01" type="number" :error-messages="errors.collect('Rate')">></v-text-field>
                                                  </v-col>
                                                  <v-col cols="12" v-if="znanyLekarzEnabled">
                                                    <v-select :items="znanyLekarzDoctors" label="Przypisanie w Znanym Lekarzu" v-model="selectedDoctor" clearable>
                                                    </v-select>
                                                  </v-col>
                                                  <v-col cols="12">
                                                    <label for="color">Przypisany kolor:</label>
                                                    <ColorPicker :color="Color" v-model="Color" />
                                                  </v-col>                                                  
                                                  <v-col cols="12">
                                                    <!--Create select for groups and bind it for selectedGroup-->
                                                    <v-select :items="groups" v-model="selectedGroup" clearable label="Grupa terapeuty" item-text="name" return-object placeholder="Wybierz grupę..."></v-select>
                                                  </v-col>
                                                  <v-col cols="12" v-if="portalSyncEnabled">
                                                    <v-checkbox
                                                        v-model="isPortalEnabled"
                                                        label="Widoczny w portalu pacjenta"
                                                        hint="Zaznacz, jeśli terapeuta ma być widoczny w portalu pacjenta do rezerwacji online"
                                                        persistent-hint
                                                    ></v-checkbox>
                                                  </v-col>
                                                </v-row>
                                                <v-row>
                                                  <v-col cols="12">
                                                    <v-textarea
                                                        label="Szablon sms potwierdzające wizytę"
                                                        hint="Specjalne wstawki: %dw% - data wizyty, %gw% - godzina wizyty, %tw% - imie i nazwisko terapeuty"
                                                        v-model="smsTemplate"
                                                    ></v-textarea>
                                                  </v-col>
                                                </v-row>
                                              </v-container>
                                            </v-card-text>
                                          </v-card>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-col>
                                  <v-col>
                                    <v-container  grid-list-xl v-if="id > 0">
                                      <v-row>
                                        <v-col cols="12">
                                          <v-card>
                                            <v-toolbar flat color="white">
                                              <v-toolbar-title>Kategorie ICD9</v-toolbar-title>
                                            </v-toolbar>
                                            <v-card-text>
                                              <v-list>
                                                <v-list-item v-for="(item,index) in icd9Categories" :key="index">
                                                  <v-list-item-content>
                                                    {{item.category + ' - '+item.description}}
                                                  </v-list-item-content>
                                                  <v-list-item-action>
                                                    <v-icon small @click="removeIcd9(item.id)" title="Usuń kategorie">fa-trash-alt</v-icon>
                                                  </v-list-item-action>
                                                </v-list-item>
                                              </v-list>
                                            </v-card-text>
                                            <v-divider></v-divider>
                                            <v-card-actions>
                                              <v-spacer></v-spacer>
                                              <v-btn color="success" depressed @click="showAddIcd9 = true">Dodaj</v-btn>
                                            </v-card-actions>
                                          </v-card>
                                        </v-col>
                                      </v-row>
                                      <v-row>
                                        <v-col cols="12">
                                          <v-card>
                                            <v-toolbar flat color="white">
                                              <v-toolbar-title>Ustawienia P1 (CEZ) </v-toolbar-title>
                                            </v-toolbar>
                                            <v-card-text>
                                              <v-container fluid>
                                                <v-row>
                                                  <v-col cols="12">
                                                    <v-select :items="organizational_units"  item-text="nazwa"
                                                              label="Domyślna komórka organizacyjna" placeholder="Wybierz domyślną komórkę organizacyjna..."
                                                              v-model="organizational_unit"
                                                              return-object
                                                              name="organizational_unit"
                                                              id="organizational_unit"
                                                    ></v-select>
                                                  </v-col>
                                                </v-row>
                                                <v-row>
                                                  <v-col cols="12">
                                                    <v-select :items="medial_professions" v-model="plMedicalProfession" label="Grupa zawodowa" item-text="opis" return-object placeholder="Wybierz grupę zawodowa..."></v-select>
                                                  </v-col>
                                                </v-row>
                                                <v-row v-if="plMedicalProfession != null && plMedicalProfession.recepty">
                                                  <v-col cols="12">
                                                    <v-select :items="medical_chambers" v-model="selectedMedicalChamber" label="Izba lekarska" item-text="name" return-object placeholder="Wybierz izbe lekarską..."/>
                                                  </v-col>
                                                </v-row>
                                                <v-row v-if="this.id > 0 && plMedicalProfession != null && plMedicalProfession.recepty">
                                                  <v-col cols="4" class="d-flex align-center">
                                                    <v-btn color="success" @click="showUploadCertificate = true">Wgraj certyfikat</v-btn>
                                                  </v-col>
                                                  <v-col cols="8" class="d-flex align-center" style="font-weight: bold">
                                                    {{ CzyCertyfikatWgrany ? (DataWaznosciCertyfikatu != null ? 'Data ważności certyfikatu: '+ getFormattedDate(DataWaznosciCertyfikatu) : 'Certyfikat wgrany') : 'Brak wgranego certyfikatu'}}
                                                  </v-col>
                                                </v-row>
                                              </v-container>
                                            </v-card-text>
                                          </v-card>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item key="1">
                        <v-card flat>
                            <v-card-text>
                                <v-container  grid-list-xl fluid>
                                    <v-layout row wrap v-for="item in schedule" :key="item.day" class="editTherapist">        
                                        <v-flex xs2><span>{{ item.name}}</span></v-flex>
                                        <v-flex xs3>
                                            <v-checkbox
                                                v-model="item.isenabled"
                                                label="Dostępność"
                                                style="margin-top: 0px; padding-top: 0px"
                                            ></v-checkbox>                                                                                        
                                        </v-flex>
                                        <v-flex xs3>                                                
                                            <TimePicker v-show="item.isenabled" v-model="item.timestart" text="Początek"></TimePicker>
                                        </v-flex>
                                        <v-flex xs3> 
                                            <TimePicker v-show="item.isenabled" v-model="item.timeend" text="Koniec"></TimePicker>                                            
                                        </v-flex>
                                    </v-layout>
                                </v-container>                                
                            </v-card-text>
                        </v-card>
                    </v-tab-item>     
                    <v-tab-item key="2">
                        <TherapistBreaks v-if="active_tab == 2" :breaks.sync="breaks" :therapistID="TherapistID" />
                    </v-tab-item>
                    <v-tab-item key="3">
                        <Holidays :therapistid="TherapistID" v-if="active_tab == 3" />
                    </v-tab-item>
                     <v-tab-item key="4">
                         <QuickBreaks :therapistID="TherapistID" v-if="active_tab == 4"></QuickBreaks>
                     </v-tab-item>
                    <v-tab-item key="5">
                        <TypyWizytTerapeuty :id="UserID" v-if="active_tab == 5"></TypyWizytTerapeuty>
                    </v-tab-item>
                   <v-tab-item key="6">
                     <AdditionalOpenDays :therapistID="TherapistID" v-if="active_tab == 6"></AdditionalOpenDays>
                   </v-tab-item>
                 </v-tabs>
        </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="closeForm" color="error">Zamknij</v-btn>
          <v-btn color="success" @click="handleSubmit">Zapisz</v-btn>
        </v-card-actions>
    </v-card>
    <AddICD9 v-if="showAddIcd9" :visible="showAddIcd9" :actualTherapistCategories="icd9Categories" @onsubmit="icd9Submit" @close="showAddIcd9 = false"></AddICD9>
    <v-row>
      <v-dialog v-model="showUploadCertificate" width="768" persistent>
        <UploadCertificate  v-if="showUploadCertificate" :therapistid="this.UserID" @close="showUploadCertificate = false" @uploaded="uploadedCertificate"></UploadCertificate>
      </v-dialog>
    </v-row>
  </v-dialog>
</template>

<script>
import { therapistsService } from "@/services/";
import TimePicker from "@/components/shared/TimePicker"
import ColorPicker from "@/components/shared/ColorPicker"
import TherapistBreaks from "./TherapistBreaks"
import swal from "sweetalert";
import QuickBreaks from "./QuickBreaks";
import {settingsService} from "../../services";
import {znanyLekarzService} from "../../services/znanylekarz.service";
import AddICD9 from "@/components/therapists/AddICD9";
import TypyWizytTerapeuty from "@/components/therapists/TypyWizytTerapeuty";
import AdditionalOpenDays from "@/components/therapists/AdditionalOpenDays.vue";
import * as dayjs from "dayjs";
import UploadCertificate from "@/components/therapists/UploadCertificate.vue";



export default {
    name: 'EditTherapist',
    data() {
        return {
            title: "",
            loading: false,
            visibility_class: 'row',
            initialized: false,         
            saving: false,
            UserID: null,            
            Name: null,
            Surname: null,
            showUploadCertificate: false,
            EmailAddress: null,
            DataWaznosciCertyfikatu: null,
            CzyCertyfikatWgrany: false,
            Phone: null,
            PWZ: null,
            breaks: [],
            icd9Categories: [],
            VisitTime: 0,
            Rate: 0,
            Color: '0',
            TherapistID: 0,
            active_tab: 0,
            znanyLekarzEnabled: false,
            znanyLekarzPlacowkaId: 0,
            znanyLekarzId: 0,
            selectedDoctor: null,
            showAddIcd9: false,
            organizational_unit: null,
            selectedMedicalChamber: null,
            plMedicalProfession: null,
            selectedGroup: null,
			colors: {
				hex: '#000000',
            },   
            displayPicker: false,  
            schedule: [                
                { day: 1, name: 'Poniedziałek', isenabled: false, timestart: '', timeend: '', id: 0},
                { day: 2, name: 'Wtorek', isenabled: false, timestart: '', timeend: '', id: 0},
                { day: 3, name: 'Środa', isenabled: false, timestart: '', timeend: '', id: 0},
                { day: 4, name: 'Czwartek', isenabled: false, timestart: '', timeend: '', id: 0},
                { day: 5, name: 'Piątek', isenabled: false, timestart: '', timeend: '', id: 0},
                { day: 6, name: 'Sobota', isenabled: false, timestart: '', timeend: '', id: 0},                                                                
                { day: 0, name: 'Niedziela', isenabled: false, timestart: '', timeend: '', id: 0}
            ],
            timeConfig: {
                enableTime: true,
                noCalendar: true,
                time_24hr: true,
                allowInput: true,
                defaultHour: 0
            },
            znanyLekarzDoctors: [],
            smsTemplate: null,
            portalSyncEnabled: false,
            isPortalEnabled: false
        }
    },
    props: ["id","visible","organizational_units","medial_professions","medical_chambers","groups"],
    methods: {
        showError(close, text) {
            swal({
                title: "Błąd",
                text: text,
                icon: "warning",
                button: "OK"
            }).then(() => {
                this.loading = false;
                if (close) {
                this.$emit("close");
                }
            });
        },
        hide() {
            this.visibility_class = 'row scale-transition scale-out'
            this.saving = true
        },
        show() {
            this.visibility_class = 'row'
            this.saving = false
        },
        uploadedCertificate(date)
        {
          this.DataWaznosciCertyfikatu = date
          this.CzyCertyfikatWgrany = true
          this.showUploadCertificate = false
        },
        clearFormData() {
            this.schedule.forEach(elem => {
                elem.timestart = ''
                elem.timeend = ''
                elem.id = 0
                elem.isenabled = false
            })
            this.UserID = null
            this.Name = null
            this.Surname = null
            this.EmailAddress = null
            this.Phone = null
            this.PWZ = null
            this.VisitTime = 0
            this.Rate = 0
            this.Color = '0'
            this.TherapistID = 0
            this.active_tab =  0
            this.znanyLekarzId = 0
            this.breaks = []
            this.smsTemplate = null
            this.selectedMedicalChamber = null
            this.isPortalEnabled = false
        },
        closeForm() {            
            this.$emit("close");
            this.clearFormData()
        },
        handleSubmit() {
            this.active_tab = 0
            var invalidDays = this.schedule
                .filter(s => s.isenabled && (!s.timestart || !s.timeend))
                .map(s => s.name)
            if (invalidDays.length > 0) {
                this.active_tab = 1
                this.showError(false, "Uzupełnij godziny pracy dla zaznaczonych dni: " + invalidDays.join(", "))
                return
            }
            this.$validator.validate().then(valid => {
                    if (valid) {
                        this.saveTherapist();
                    }
                });
        },
        saveTherapist() {
            this.hide()

            var dataToSave = {
                userID: this.UserID,
                phone: this.Phone,
                pwz: this.PWZ,
                visitTime: this.VisitTime,
                rate: this.Rate,
                color: this.Color,
                therapistID: this.TherapistID,
                znanyLekarzId: this.selectedDoctor,
                mainOrganizationalUnitID: this.organizational_unit ? this.organizational_unit.id : 0,
                plMedicalProfession: this.plMedicalProfession != null ? this.plMedicalProfession.kod : 0,
                smsTemplate: this.smsTemplate,
                medicalChamberCode: this.selectedMedicalChamber != null ? this.selectedMedicalChamber.code : null,
                groupId: this.selectedGroup != null ? this.selectedGroup.id : 0,
                isPortalEnabled: this.isPortalEnabled,
            }
            var sl = []
            this.schedule.forEach(el => {                
                sl.push({day: el.day, timeStart: el.timestart, timeEnd: el.timeend,isEnabled: el.isenabled, id: el.id})
            })
            dataToSave.schedules = sl

            therapistsService.save(
                dataToSave    
            ).then(() => { 
                this.show()       
                this.closeForm()
            }).catch(resp => {
                if(resp.response != null && resp.response.data != null && resp.response.data.error != null)
                {
                    this.showError(false,resp.response.data.error.message)         
                       
                }
                else
                {
                    this.showError(false,'Błąd zapisu terapeuty')
                }
                this.show()
            })  
        },
        loadCompanyData() {
            this.loading = true
            settingsService.GetCompanySettings().then(success=> {

                if(success.data.result)
                {
                    let data = success.data.result
                    if(data.id > 0)
                    {
                        this.znanyLekarzEnabled = data.znanyLekarzEnabled
                        this.znanyLekarzPlacowkaId = data.znanyLekarzPlacowkaId
                        this.portalSyncEnabled = data.portalSyncEnabled
                    }
                    if(this.znanyLekarzPlacowkaId > 0)
                    {
                        this.loadZnanyLekarzDoctors()
                    }
                }
                else
                {
                    throw 'error'
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
                this.showError(false,"Błąd pobierania ustawień firmy.")
            })
        },
        loadZnanyLekarzDoctors()
        {
            this.loading = true
            znanyLekarzService.GetDoctors().then(result=> {
                if(result.data && result.data.result)
                {
                    result.data.result.forEach(itm => {

                      this.znanyLekarzDoctors.push({
                        value: Number(itm.id),
                        text: itm.name + ' '+itm.surname
                      })
                    })
                  //  this.znanyLekarzDoctors = result.data.result

                }
                this.loading = false
            }).catch(() => {
                this.showError(false,"Błąd pobierania danych ze znanego lekarza.")
                this.loading = false
            })
        },
        loadTherapistData() {
                this.loading = true;

                if(this.id == 0) return
                therapistsService.getDetails(this.id).then(resp => {

                if (resp.data != null && resp.data.success && resp.data.result != null) {
                    let therapist = resp.data.result
                    this.title = "Dane terapeuty: "+therapist.name+ " "+therapist.surname
                    this.Name = therapist.name
                    this.Surname = therapist.surname
                    this.EmailAddress = therapist.emailAddress
                    this.Phone = therapist.phone
                    this.VisitTime = therapist.visitTime
                    this.Color = therapist.color,
                    this.UserID = therapist.userID,
                    this.PWZ = therapist.pwz,
                    this.Rate = therapist.rate,
                    this.TherapistID =  therapist.therapistID
                    this.breaks = therapist.rests != null ? therapist.rests : []
                    this.selectedDoctor = therapist.znanyLekarzId
                    this.icd9Categories = therapist.icD9Categories
                    this.plMedicalProfession =  this.medial_professions.find(x=>x.kod == therapist.plMedicalProfession)
                    this.smsTemplate = therapist.smsTemplate
                    this.selectedMedicalChamber = this.medical_chambers.find(x=>x.code == therapist.medicalChamberCode)
                    this.DataWaznosciCertyfikatu = therapist.dataWaznosciCertyfikatu
                    this.CzyCertyfikatWgrany = therapist.czyCertyfikatWgrany
                    this.isPortalEnabled = therapist.isPortalEnabled
                    if(therapist.groupId && therapist.groupId > 0)
                    {
                        this.selectedGroup = this.groups.find(x=>x.id == therapist.groupId)
                    }
                    if(therapist.schedules != null )
                    {
                        therapist.schedules.forEach(elem => {
                            var sched = this.schedule.find(x=>x.day == elem.day)
                            if(sched != null) {
                              sched.timestart = elem.timeStart
                              sched.timeend = elem.timeEnd,
                              sched.isenabled = elem.isEnabled
                              sched.id = elem.id
                            }
                        })

                    }
                    if(therapist.mainOrganizationalUnitID > 0)
                    {
                      let org = this.organizational_units.find(x=>x.id == therapist.mainOrganizationalUnitID)
                      this.organizational_unit = org
                    }
                } else {
                    throw "Error: " + resp.data.error;
                }

                this.loading = false;
            }).catch(e => {
              console.log(e)
            this.showError(true, "Nie można pobrać informacji o terapeucie.");
            this.loading = false;
            });
        },
        icd9Submit(value)
        {
          therapistsService.AddIcd9Category(value.kod, this.TherapistID).then((res) => {
            this.icd9Categories.push({
              id: res.data.id,
              category: value.kod,
              description: value.opis,
              therapistId: this.TherapistID
            })
          }).catch(() => {
            this.showError(false, "Nie można dodać kategorii.");
          })
          this.showAddIcd9 = false
        },
        removeIcd9(id)
        {
          therapistsService.DeleteIcd9Category(id).then(()=> {
            this.icd9Categories = this.icd9Categories.filter(function(obj) {
              return obj.id !== id;
            })
          }).catch(()=> {
            this.showError(false, "Nie usunąc kategorii ICD9.");
          })
        },
        getFormattedDate(val)
        {
          let dj = dayjs(val)
          if(dj != null)
          {
            return dj.format("DD-MM-YYYY")
          }
          else
          {
            return val
          }
        },
    },
    mounted() {
        this.loadCompanyData()
    },
    components: {
      UploadCertificate,
      AdditionalOpenDays,
      TypyWizytTerapeuty,
      AddICD9,
        QuickBreaks,
        ColorPicker,   
        TimePicker,
        TherapistBreaks,
        Holidays: () => import("@/components/therapists/Holidays")   
    },
    created() {
        this.loading = true;
 
        this.loadTherapistData()
            
 
    },
    computed: {
        showModal: {
            get: function() {
                if(!this.visible)
                {
                    this.clearFormData()
                    this.errors.clear();
                }
                return this.visible
            },
            set: function(value) {                
                if(!value){
                this.$emit('close')
                }

            }
        }
    },  
    watch: {
        id: function(newId)
        {

            if(newId > 0)
            {                
                this.clearFormData()
                this.loading = true
                this.loadTherapistData()
            }
            else
            {
                this.clearFormData()
                this.errors.clear();
            }

        }
    }       
}
</script>

<style>
    .editTherapist input.flatpickr-input
    {
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
        border-bottom: 1px dashed black;
        text-align:center;
    }
</style>
